import isNaN from 'lodash/isNaN';
import React from 'react';
import styled from 'styled-components';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { grey75 } from '@zocdoc/branding/colors';

function roundToNearestHalf(num) {
    return Math.round(num * 2) / 2;
}

const DoctorLocationDistance = ({ className, distance, style }) => {
    const distanceNum = parseInt(distance, 10);

    if (isNaN(distanceNum) || distanceNum < 0) {
        return null;
    }

    return (
        <DoctorCardInfoLocationDistance
            className={className}
            data-test="lightweight-doctor-card-info-location-distance"
            style={style}
        >
            {roundToNearestHalf(distanceNum)}mi
        </DoctorCardInfoLocationDistance>
    );
};

const DoctorCardInfoLocationDistance = styled.div`
    font-family: ${FontFamily.SharpSansSemibold};
    font-size: 12px;
    text-align: right;
    color: ${grey75};
`;

export default DoctorLocationDistance;
